import React from 'react'
import {connect} from 'react-redux'
import {getQueryResults, applyFilter} from '../../../redux/modules/search'
import {toggleSearchIsFocused} from '../../../redux/modules/ui'
import qs from 'query-string'
import Search from '../components/Search'

class VisibleSearch extends React.PureComponent {
  componentDidMount() {
    const {getQueryResults, applyFilter} = this.props
    const search = qs.parse(window.location.search, {arrayFormat: 'bracket'})
    if (search.q) {
      getQueryResults(search.q)
    }
    if (search.filters) {
      for (let filter of search.filters) {
        applyFilter(filter)
      }
    }
    //closeEntrySearch();
  }

  render() {
    return (
      <Search {...this.props} />
    )
  }
}

const mapDispatchToProps = dispatch => ({
  getQueryResults: (query) => {
    dispatch(getQueryResults(query))
  },
  applyFilter: (filter) => dispatch(applyFilter(filter)),
  closeEntrySearch: () => dispatch(toggleSearchIsFocused(false))
})

export default connect(
  null,
  mapDispatchToProps
)(VisibleSearch)



// WEBPACK FOOTER //
// ./src/domains/search/containers/VisibleSearch.js